<script setup>
import dayjs from 'dayjs';
import { onMounted } from 'vue';
import { useAuthStore } from '~/stores/auth';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['loaded']);
const authStore = useAuthStore();

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    :label-style="{ width: '25%' }"
    bordered
  >
    <a-descriptions-item
      v-if="!isNilOrEmpty(props.compromisso.data.haPrazo)"
      label="Há prazo?"
      :span="3"
    >
      {{ props.compromisso.data.haPrazo ? 'Sim' : 'Não' }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="props.compromisso.data.tipo"
      label="Tipo"
      :span="3"
    >
      {{ props.compromisso.data.tipoText ?? '-' }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="props.compromisso.data.tipoClassificacaoPublicacaoCaq"
      label="Tipo"
      :span="3"
    >
      {{ props.compromisso.data.tipoClassificacaoPublicacaoCaqText ?? '-' }}
    </a-descriptions-item>

    <a-descriptions-item
      label="Observação"
      :span="3"
    >
      {{ props.compromisso.data?.observacao ?? '-' }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="props.compromisso.data.haPrazo === true"
      label="Prazo"
      :span="3"
    >
      {{
        props.compromisso.data.prazo
          ? dayjs
            .utc(props.compromisso.data.prazo)
            .tz(authStore.timeZone)
            .format('DD/MM/YYYY HH:mm')
          : '-'
      }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="props.compromisso.data.haPrazo === false"
      label="Data de cumprimento"
      :span="3"
    >
      {{
        props.compromisso.data.dataCumprimento
          ? dayjs
            .utc(props.compromisso.data.dataCumprimento)
            .tz(authStore.timeZone)
            .format('DD/MM/YYYY HH:mm')
          : '-'
      }}
    </a-descriptions-item>

    <a-descriptions-item
      label="Arquivos"
      :span="3"
    >
      <span v-if="props.compromisso.arquivos.length === 0">Nenhum arquivo enviado</span>
      <ul v-else>
        <li
          v-for="arquivo in props.compromisso.arquivos"
          :key="arquivo.fileServiceId"
        >
          <a
            target="_blank"
            :href="getGoogleDriveUrl(arquivo.fileServiceId)"
          >{{
            arquivo.nome
          }}</a>
        </li>
      </ul>
    </a-descriptions-item>
  </a-descriptions>
</template>
